import Grid from '@mui/material/Grid';
import BaseTable from 'components/Tables/BaseTable';
import { alertError } from 'ducks/alerts';
import { actions } from 'ducks/products';
import { setContextSearchProduct } from 'ducks/ui';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import docDefinition from 'reports/products/productComposition';
import { getImmutableStoreById, getImmutableStoreData, groupBy } from 'selectors/generic';
import theme from 'source/theme';
import { MIXTURE } from 'utils/constants/coreConstants';
import { DISTRIBUIDOR, IMPORTADOR } from 'utils/constants/reach_role';
import tableIcons, { DistributionIcon } from 'utils/icons/materialTableIcons';
import productColumns from 'utils/tables/columns/initialProduct';
import validator from 'utils/tables/validators/product';
import { currentUser } from 'selectors/currentUser';

pdfMake.addVirtualFileSystem(pdfFonts);

// `product.product_raw_materials` used to arrive nested inside the product; it
// is the composition table keyed by product_id. Three of the row actions below
// ask it a question, once per product per render.
const compositionByProduct = groupBy('productRawMaterials', 'product_id');

const Component = props => {
  const { composition, contextSearch, products, rawMaterialsById, user } = props;
  const { setInOutFinalRM, setProductId, setSearch, update } = props;
  const tableRef = React.useRef(null);

  const [loading, setLoading] = useState(false);

  const exportPDF = () => {
    const filteredTableData = tableRef.current.state.data;
    pdfMake.createPdf(docDefinition(filteredTableData, rawMaterialsById)).open();
  };

  return (
    <Grid size={12}>
      <BaseTable
        ref={tableRef}
        columns={productColumns(user)}
        data={products}
        onRowClick={() => null}
        isLoading={loading}
        onSearchChange={ text => setSearch(text)}
        options={{
          actionsCellStyle: {
            width: 200,
            paddingLeft: 20
          },
          searchText: contextSearch
        }}
        editable={{
          onRowUpdate: (newData, oldData) => {
            setLoading(true);
            const validation = validator(newData, products);
            if (validation.error) {
              setLoading(false);
              alertError(validation.error);
              return Promise.resolve();
              // TODO Instead of rejecting we are resolving, should be rejecting.
              // Have to update library later github issue #2086
            } else {
              return update(newData.id, newData)
                .catch((e) => alert(e))
                .finally(() => setLoading(false));
            }
          }
        }}
        actions={[
          rowData => {
            if (
              rowData.reach_role === DISTRIBUIDOR ||
              rowData.reach_role === IMPORTADOR
            ) {
              return null;
            }

            const matchProductRM = (composition[rowData.id] || []).find(prm =>
              !prm.mixture_id && prm.added_to_charge &&
              rawMaterialsById[prm.raw_material_id].code !== '' &&
              rawMaterialsById[prm.raw_material_id].code !== null
            );
            return {
              icon: matchProductRM ?
                tableIcons.AddToCargo() :
                tableIcons.AddToCargo(theme.palette.error.main),
              tooltip: 'Carga',
              position: 'row',
              onClick: (event, rowData) => {
                setProductId(rowData.id);
                setInOutFinalRM('in');
              }
            };
          },
          rowData => {
            if (
              rowData.reach_role === DISTRIBUIDOR ||
              rowData.reach_role === IMPORTADOR
            ) {
              return null;
            }

            const matchProductsRM = (composition[rowData.id] || []).find(prm =>
              !prm.added_to_charge && prm.mixture_id === null &&
              rawMaterialsById[prm.raw_material_id].type !== MIXTURE
            );

            return {
              icon: matchProductsRM ?
                tableIcons.Formulation() :
                tableIcons.Formulation(theme.palette.secondary.light),
              tooltip: 'Reacção',
              position: 'row',
              onClick: (event, rowData) => {
                setProductId(rowData.id);
                setInOutFinalRM('out');
              }
            };
          },
          rowData => rowData.reach_role === DISTRIBUIDOR || rowData.reach_role === IMPORTADOR ?
            null :
            {
              icon: tableIcons.FinalProduct(),
              tooltip: 'Produto Final',
              position: 'row',
              onClick: (event, rowData) => {
                setProductId(rowData.id);
                setInOutFinalRM('final');
              }
            },
          rowData => {
            if (!(rowData.reach_role === DISTRIBUIDOR || rowData.reach_role === IMPORTADOR)) {
              return null;
            }

            const matchProductsRM = (composition[rowData.id] || []).find(prm =>
              !prm.added_to_charge && prm.mixture_id === null &&
              rawMaterialsById[prm.raw_material_id].type !== MIXTURE
            );

            return {
              icon: matchProductsRM ?
                tableIcons.Distribution() :
                tableIcons.Distribution(theme.palette.error.main),
              tooltip: 'Distribuição',
              position: 'row',
              onClick: (event, rowData) => {
                setProductId(rowData.id);
                setInOutFinalRM('distr');
              }
            };
          },
          {
            isFreeAction: true,
            icon: tableIcons.Pdf,
            tooltip: 'Exportar PDF',
            onClick: exportPDF
          }
        ]}
      />
    </Grid>
  );
};


const makeMapStateToProps = () => {
  const immutableProducts = getImmutableStoreData('products');
  const rawMaterialsById = getImmutableStoreById('rawMaterials');
  const mapStateToProps = (state, props) => ({
    composition: compositionByProduct(state),
    contextSearch: state.ui.context.searchProduct,
    products: immutableProducts(state),
    rawMaterialsById: rawMaterialsById(state),
    user: currentUser(state)
  });
  return mapStateToProps;
};

const mapDispatchToProps = dispatch => ({
  alertError: error => dispatch(alertError(error)),
  setSearch: search => dispatch(setContextSearchProduct(search)),
  update: (id, data) => dispatch(actions.updatePromise(id, data))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
